<template>
  <div class="investment-alloc-container">
      <Chart ref="DetailChart" :options="detailChartOptions"></Chart>
      <calculation-explanation @show-calcs="emit('showCalcs')"></calculation-explanation>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onBeforeUpdate } from "vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import CalculationExplanation from "../common/CalculationExplanation.vue";

const props = defineProps({
    title: { type: String, default: "Fund Splits" },
    data: { type: Array<any>, required: true }
});

const emit = defineEmits<{ (e: 'showCalcs'): void }>();

const DetailChart = ref(null);

onBeforeUpdate(() => {
  DetailChart.value.chart.reflow();
})

const getDetailChartData = computed(() => {
  const data = [
    {
      colorByPoint: true,
      data: props.data
    }
  ];

  return data;
});

const detailChartOptions = computed<object>(() => {
  return {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
      height: 280
    },
    title: {
      text: props.title,
      style: {
        color: "#5c5b5b",
        fontWeight: "600",
        fontSize: "13px"
      }
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: "pointer",
        size: "90%",
        dataLabels: {
          enabled: true,
          overflow: "justify",
          distance: 20,
          style: {
            fontSize: "0.9em",
            fontWeight: "lighter"
          },
          formatter: function() {
            return (
              this.point.name +
              ": " +
              Highcharts.numberFormat(this.y, 1, ".", ",") + "%"
            );
          }
        }
      }
    },
    series: getDetailChartData.value,
    credits: {
      enabled: false
    }
  };
});
</script>

<style>
.highcharts-container {
  width: 100% !important;
}

.investment-alloc-container {
  position: relative;
}
</style>
